// components/Footer.js
import React, { useEffect, useState, useContext } from "react";
import { useLocation } from "react-router-dom";
import NewsLetter from "./Newsletter";
import { useTranslateKey } from "../translation/useTranslateKey";
import { LangContext } from "../translation/langugeContext";
import {
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaBuilding,
  FaCity,
  FaHome,
} from "react-icons/fa";

const Footer = ({ paddingLeft }) => {
  const location = useLocation();
  const isPropertyBrowserPage = location.pathname === "/property-browser";
  const [isMobile, setIsMobile] = useState(false);
  const t = useTranslateKey();
  const { lang } = useContext(LangContext);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <footer
      className="bg-[#11132F] relative"
      style={{
        ...(isPropertyBrowserPage
          ? {
            paddingLeft: lang === "ar" ? "0px" : isMobile ? "0px" : "16.8rem",
          paddingRight: lang === "ar" ? (isMobile ? "0px" : "16.8rem") : "0px",
            }
          : 
          {
            paddingLeft:
            isMobile || !paddingLeft ? "0px" : paddingLeft,
          }),
        }}
    >
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="logo flex items-center gap-4">
              <div className={`logo-container${lang === "ar" ? " logo-container-ar" : ""}`}>
                <img src="/img/logo3copy.png" alt="Icon" className="h-10" />
                <img
                  src="/img/logocopy.png"
                  alt="Logo"
                  className="h-19 main-logo"
                />
              </div>
            </div>
            <p className="text-gray-300 mb-4 mt-6">
            {t("footerDescription")}
            </p>
            <div className={`flex space-x-4${lang === "ar" ? " flex space-x-4-ar" : ""}`}>
              <a
                href="https://www.facebook.com"
                className="text-[#F9C835] hover:text-white"
              >
                <FaFacebookF />
              </a>
              <a
                href="https://www.instagram.com"
                className="text-[#F9C835] hover:text-white"
              >
                <FaInstagram />
              </a>
              <a
                href="https://www.linkedin.com"
                className="text-[#F9C835] hover:text-white"
              >
                <FaLinkedinIn />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white text-lg font-semibold mb-6">
               {t("quickLinks")}
            </h4>
            <ul className="space-y-3 quick-links">
              <li>
                <a href="/" className="text-gray-300 hover:text-[#F9C835]">
                  <FaHome className="inline mr-2 text-2xl" /> 
                  <span className="text-gray-300">{t("home")}</span>
                </a>
              </li>
              <li>
                <a
                  href="/property-browser"
                  className="text-gray-300 hover:text-[#F9C835]"
                >
                  <FaBuilding className="inline mr-2 text-2xl" /> 
                  <span className="text-gray-300">{t("properties")}</span>
                </a>
              </li>
              <li>
                <a
                  href="/developers"
                  className="text-gray-300 hover:text-[#F9C835]"
                >
                  <FaCity className="inline mr-2 text-2xl" /> <span className="text-gray-300">{t("developers")}</span>
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white text-lg font-semibold mb-6">
              {t("contactUs")}
            </h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <FaMapMarkerAlt className="text-[#F9C835] mt-1 text-2xl" />
                <span className="text-gray-300">
                  {t("address")}
                </span>
              </li>
              <li className="flex items-center space-x-3">
                <FaPhoneAlt className="text-[#F9C835] text-2xl" />
                <span className="text-gray-300">01030282513</span>
              </li>
              <li className="flex items-center space-x-3">
                <FaEnvelope className="text-[#F9C835] text-2xl" />
                <span className="text-gray-300">realestate@ssignature.net</span>
              </li>
            </ul>
          </div>

          {/* Newsletter */}
          <NewsLetter />
        </div>

        {/* Bottom Footer */}
        <div className=" border-t border-gray-800 mt-12 pt-8 text-center">
          <div className="text-gray-400 flex items-center justify-center gap-2">
            <span>
              &copy; 2025{" "}
              <img
                src="../../../img/logo3copy.png"
                alt="Icon"
                className="h-6 inline-block"
              />
            </span>
            <span>
                  {t("allRightsReserved")}
            </span>
          </div>
          <p>
            {t("poweredBy")}{" "}
            <a href="https://oasistechsystems.net/">
              <strong style={{ color: "#F9C835" }}>Oasis Systems</strong>
            </a>
            .
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
